<template>
	<div>
		<div id="root-bg" class="bg-default py-4" v-if="showClassesList">
			<div class="container" v-if="showClassesList">
				<div class="row mt-3 mb-3">
					<div class="col-12 text-center"><h2 class="fs-2 text-white">Carica i contributi delle tue classi</h2></div>
					<div class="col-12 text-center text-white" v-if="Object.keys(msgRemovedClasses).length">
						<p class="mb-1">Le seguenti classi sono state rimosse dalla tua area personale in quanto risultano già registrate.</p>
						<span class="mr-3 bold" v-for="(cls, index) in msgRemovedClasses" :key="index">{{cls.classe}} {{cls.sezione}}</span>
					</div>
					<div class="col-12">
						<div class="row justify-content-center">
							<div class="col-md-6 col-lg-3" v-for="(cls, index) in classesList" :key="index">
								<class-box-component
									:classData="cls"
									@openWrkForm="openWorkForm"
									@openWrkFormText="openWorkFormText"
									@refreshList="reloadPage"
								></class-box-component>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="container" v-if="showClassesList">
				<div class="row justify-content-center">
					<div class="col-12 text-center mt-4 mb-3">
						<h2 class="text-white">Aggiungi classe</h2>
					</div>
					<div class="col-lg-10">
						<add-class-component
							@refreshClasses="getClassesWorks"
						></add-class-component>
					</div>
				</div>
			</div>
		</div>

		<div class="container" v-if="!showClassesList && !showTextForm">
			<div class="row mt-3 mb-3">
				<div class="col-12">
					<div class="row justify-content-center">
						<div class="col-12">
							<work-form-component
								:idClass="idClassForm"
								:idWork="idWorkForm"
								:className='workClassName'
								:url-theme="urlTheme"
								@closeWrkForm="closeWorkForm"
							></work-form-component>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="container" v-if="!showClassesList && showTextForm">
			<div class="row mt-3 mb-3">
				<div class="col-12">
					<div class="row justify-content-center">
						<div class="col-12">
							<work-form-text-component
								:idClass="idClassFormText"
								:idWork="idWorkFormText"
								:className='workClassName'
								:url-theme="urlTheme"
								@closeWrkForm="closeWorkForm"
							></work-form-text-component>
						</div>
					</div>
				</div>
			</div>
		</div>

		<v-dialog />
	</div>
</template>

<script>
import Vue from 'vue'
const jQuery = window.jQuery
import axios from 'axios'
import VModal from 'vue-js-modal'
Vue.use(VModal, { dialog: true })
import ClassBoxComponent from './ClassBoxComponent.vue'
import WorkFormComponent from './WorkFormComponent.vue'
import WorkFormTextComponent from './WorkFormTextComponent.vue'
import AddClassComponent from './AddClassComponent.vue'

export default {
	name: 'RootWorksManagementComponent',
	props: ['urlTheme'],
	components: {ClassBoxComponent, WorkFormComponent, WorkFormTextComponent, AddClassComponent},
	data() {
		return {
			ajaxObj: window.ajax_object,
			classesList: {},
			showClassesList: true,
			showTextForm: false,
			idClassForm: 0,
			idWorkForm: 0,
			idClassFormText: 0,
			idWorkFormText: 0,
			workClassName: '',
			msgRemovedClasses: {}
		}
	},

	methods: {
		getClassesWorks() {
			let url = this.ajaxObj.ajax_url

			var data = new FormData();
			data.append('action', 'nl_get_user_class_list')
			data.append('_nounce_value', this.ajaxObj._nounce_value)

			axios.post(url, data)
				.then((response) => {
					// console.log(response.data)
					this.classesList = response.data
				}, (error) => {
					console.log(error);
				});
		},

		checkDuplicatedClasses() {
			let url = this.ajaxObj.ajax_url

			var data = new FormData();
			data.append('action', 'nl_check_duplicated_classes')
			data.append('_nounce_value', this.ajaxObj._nounce_value)

			axios.post(url, data)
				.then((response) => {
					// console.log(response.data)
					this.msgRemovedClasses = response.data.duplicated
				}, (error) => {
					console.log(error);
				});
		},

		openWorkForm(data) {
			this.idClassForm = data.classId
			this.idWorkForm = data.workId
			this.workClassName = data.classe + '' + data.sezione

			this.showClassesList = false
			this.showTextForm = false
		},

		openWorkFormText(data) {
			this.idClassFormText = data.classId
			this.idWorkFormText = data.workId
			this.workClassName = data.classe + '' + data.sezione

			this.showClassesList = false
			this.showTextForm = true
		},

		closeWorkForm() {
			this.idClassForm = 0
			this.idWorkForm = 0

			this.showClassesList = true
			jQuery('#welcome-text').text('Benvenuto nella tua area riservata.')
			jQuery('.form-work-open').removeClass('d-none')
			setTimeout(() => {
				jQuery("#root-bg").get(0).scrollIntoView({behavior: "smooth"})
			}, 400);

			/*jQuery('#intro-text').removeClass('d-none')
			jQuery('#intro-text-1').removeClass('d-none')
			jQuery('#school-message').removeClass('d-none')*/
		},
		reloadPage() {
			window.location.reload();
		}
	},

	mounted() {
		this.getClassesWorks()
		this.checkDuplicatedClasses()
	}
}
</script>
